import { render, staticRenderFns } from "./DialogConfirmButton.vue?vue&type=template&id=182fc6f0&scoped=true&"
import script from "./DialogConfirmButton.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmButton.vue?vue&type=style&index=0&id=182fc6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182fc6f0",
  null
  
)

export default component.exports